import React from "react";
import styled from "@emotion/styled";

import FormControlLabel from "@mui/material/FormControlLabel";
import MuiCheckbox from "@mui/material/Checkbox";
import ParkkiTheme from "themes/ParkkiTheme";

const StyledCheckbox = styled(MuiCheckbox)`
  color: ${ParkkiTheme.colors.turquoise};
  padding-right: ParkkiTheme.spacings.tiny;
`;

const StyledLabel = styled.span`
  opacity: 0.85;
  color: ${(props) => props.color};
`;

type Props = {
  checked?: boolean;
  disabled?: boolean;
  label?: string;
  labelColor: string;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    value: boolean
  ) => void;
};

function Checkbox({
  label,
  labelColor,
  disabled,
  ...rest
}: Props): JSX.Element {
  return (
    <FormControlLabel
      label={<StyledLabel color={labelColor}>{label}</StyledLabel>}
      control={<StyledCheckbox disabled={disabled} {...rest} />}
    />
  );
}

Checkbox.defaultProps = {
  labelColor: ParkkiTheme.colors.white,
};

export default Checkbox;
